/*eslint-disable */
export function evaluate({currentOperand, previousOperand, operation}){
    const prev = parseFloat(previousOperand)
    const current = parseFloat(currentOperand)
    if(isNaN(prev) || isNaN(current)) return ""
    let computation = ""
    switch (operation){
      case "+":
        computation = prev + current
        break
      case "-":
        computation = prev - current
        break
      case "*":
        computation = prev * current
        break
      case "÷":
          computation = prev / current
          break
    }
  
    return computation.toString()
  }
   /* eslint-enable */